import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';

const Fireworks = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;

    const particles = [];
    const fireworks = [];

    class Particle {
      constructor(x, y, color) {
        this.x = x; this.y = y; this.color = color;
        this.vx = (Math.random() - 0.5) * 8;
        this.vy = (Math.random() - 0.5) * 8;
        this.alpha = 1;
        this.gravity = 0.15;
        this.decay = Math.random() * 0.02 + 0.015;
        this.radius = Math.random() * 3 + 1;
      }
      update() {
        this.vx *= 0.98; this.vy *= 0.98;
        this.vy += this.gravity;
        this.x += this.vx; this.y += this.vy;
        this.alpha -= this.decay;
      }
      draw() {
        ctx.save();
        ctx.globalAlpha = this.alpha;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        ctx.fillStyle = this.color;
        ctx.shadowBlur = 6; ctx.shadowColor = this.color;
        ctx.fill();
        ctx.restore();
      }
    }

    class Firework {
      constructor() {
        this.x = Math.random() * canvas.width;
        this.y = canvas.height;
        this.tx = Math.random() * canvas.width;
        this.ty = Math.random() * canvas.height * 0.5;
        const dx = this.tx - this.x, dy = this.ty - this.y;
        const dist = Math.sqrt(dx*dx + dy*dy);
        this.vx = dx / dist * 12; this.vy = dy / dist * 12;
        this.alpha = 1;
        this.colors = ['#ff4444','#ff8800','#ffff00','#00ff88','#00ccff','#ff00ff','#ffffff','#ff6699'];
        this.color = this.colors[Math.floor(Math.random() * this.colors.length)];
        this.exploded = false;
        this.trail = [];
      }
      update() {
        this.trail.push({x: this.x, y: this.y, alpha: 1});
        if (this.trail.length > 8) this.trail.shift();
        this.x += this.vx; this.y += this.vy;
        if (Math.abs(this.x - this.tx) < 15 && Math.abs(this.y - this.ty) < 15) {
          this.exploded = true;
          const count = 80 + Math.floor(Math.random() * 60);
          for (let i = 0; i < count; i++) particles.push(new Particle(this.x, this.y, this.color));
        }
      }
      draw() {
        this.trail.forEach((t, i) => {
          ctx.save();
          ctx.globalAlpha = (i / this.trail.length) * 0.6;
          ctx.beginPath();
          ctx.arc(t.x, t.y, 2, 0, Math.PI * 2);
          ctx.fillStyle = this.color;
          ctx.shadowBlur = 4; ctx.shadowColor = this.color;
          ctx.fill();
          ctx.restore();
        });
        ctx.save();
        ctx.globalAlpha = 1;
        ctx.beginPath();
        ctx.arc(this.x, this.y, 3, 0, Math.PI * 2);
        ctx.fillStyle = 'white';
        ctx.shadowBlur = 8; ctx.shadowColor = 'white';
        ctx.fill();
        ctx.restore();
      }
    }

    let frame = 0;
    const animate = () => {
      ctx.fillStyle = 'rgba(0,0,0,0.15)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      frame++;
      if (frame % 25 === 0) fireworks.push(new Firework());
      for (let i = fireworks.length - 1; i >= 0; i--) {
        fireworks[i].update();
        fireworks[i].draw();
        if (fireworks[i].exploded) fireworks.splice(i, 1);
      }
      for (let i = particles.length - 1; i >= 0; i--) {
        particles[i].update();
        particles[i].draw();
        if (particles[i].alpha <= 0) particles.splice(i, 1);
      }
      requestAnimationFrame(animate);
    };
    const animId = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animId);
  }, []);

  return <canvas ref={canvasRef} style={{position:'fixed',top:0,left:0,width:'100%',height:'100%',zIndex:9998,pointerEvents:'none'}} />;
};

const WelcomeModal = () => {
  const { user } = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user) return;
    const today = new Date();
    const day = today.getDay();
    const date = today.getDate();
    const isFirstOfMonth = date === 1 && day !== 0;
    const isMondayAfterFirst = date === 2 && day === 1;
    if (!isFirstOfMonth && !isMondayAfterFirst) return;
    setShow(true);
  }, [user]);

  if (!show) return null;

  const firstName = user?.full_name?.split(' ')[0] || user?.username || 'Campeón';

  return (
    <>
      <Fireworks />
      <div style={{
        position:'fixed',top:0,left:0,width:'100%',height:'100%',
        zIndex:9999,display:'flex',alignItems:'center',justifyContent:'center',
        pointerEvents:'none'
      }}>
        <div style={{
          background:'linear-gradient(135deg, rgba(26,82,118,0.95), rgba(46,134,193,0.95))',
          borderRadius:'24px',padding:'48px 40px',maxWidth:'480px',width:'90%',
          textAlign:'center',boxShadow:'0 25px 60px rgba(0,0,0,0.6)',
          animation:'slideUp 0.6s ease',pointerEvents:'all',
          position:'relative',overflow:'hidden',
          border:'1px solid rgba(255,255,255,0.2)'
        }}>
          <div style={{position:'absolute',top:'-40px',right:'-40px',width:'150px',height:'150px',borderRadius:'50%',backgroundColor:'rgba(255,255,255,0.05)'}}></div>
          <div style={{position:'absolute',bottom:'-30px',left:'-30px',width:'120px',height:'120px',borderRadius:'50%',backgroundColor:'rgba(255,255,255,0.05)'}}></div>
          <div style={{fontSize:'56px',marginBottom:'12px'}}>🎉</div>
          <h1 style={{color:'white',fontSize:'28px',fontWeight:'800',marginBottom:'8px'}}>¡Feliz inicio de mes!</h1>
          <h2 style={{color:'#aed6f1',fontSize:'22px',fontWeight:'600',marginBottom:'20px'}}>{firstName} 👋</h2>
          <p style={{color:'rgba(255,255,255,0.95)',fontSize:'17px',lineHeight:'1.7',marginBottom:'8px'}}>
            Da siempre lo mejor de ti.
          </p>
          <p style={{color:'#aed6f1',fontSize:'14px',fontStyle:'italic',marginBottom:'28px'}}>— Att: El Jefe ❤️</p>
          <div style={{display:'flex',justifyContent:'center',gap:'8px',marginBottom:'28px'}}>
            {['💪','🚀','⭐','🏆','💡'].map((e,i) => (
              <span key={i} style={{fontSize:'24px',display:'inline-block',animation:`bounce 0.8s ease ${i*0.15}s infinite alternate`}}>{e}</span>
            ))}
          </div>
          <button
            onClick={() => setShow(false)}
            style={{backgroundColor:'white',color:'#1a5276',border:'none',borderRadius:'50px',padding:'12px 40px',fontSize:'16px',fontWeight:'700',cursor:'pointer',boxShadow:'0 4px 15px rgba(0,0,0,0.3)'}}
            onMouseOver={e=>e.target.style.transform='scale(1.05)'}
            onMouseOut={e=>e.target.style.transform='scale(1)'}
          >¡Vamos con todo! 💥</button>
        </div>
      </div>
      <style>{`
        @keyframes slideUp { from{transform:translateY(40px);opacity:0} to{transform:translateY(0);opacity:1} }
        @keyframes bounce { from{transform:translateY(0)} to{transform:translateY(-8px)} }
      `}</style>
    </>
  );
};

export default WelcomeModal;
